import { createFileRoute, redirect } from "@tanstack/react-router";
import { EditContent, Settings } from "@/features/consent-solutions";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";
import { checkUserPermissions } from "@/features/auth";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/settings/")({
  beforeLoad: async ({ context, params }) => {
    const { userDetails } = context as AuthorizedRouteContext;
    const { csId } = params;

    const isUserPermitted = checkUserPermissions(userDetails, ["CONSENT_SOLUTION_VIEW"], csId);

    if (!isUserPermitted) {
      redirect({
        to: "/consent-solutions",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => (
    <EditContent>
      <Settings />
    </EditContent>
  ),
});

export { Route };
